import {
  GiftIcon,
  GlobeIcon,
  HomeIcon,
  WalletIcon,
} from "@/app/components/common/Icons";

/**
 * Icon for each card position, used until a tenant uploads its own. Shared so
 * the dashboard preview shows the same card the home page renders.
 */
const DEFAULT_TRAVEL_FEATURE_ICONS = [
  <HomeIcon key="home" />,
  <GlobeIcon key="globe" />,
  <WalletIcon key="wallet" />,
  <GiftIcon key="gift" />,
];

export const getDefaultTravelFeatureIcon = (index: number) =>
  DEFAULT_TRAVEL_FEATURE_ICONS[index % DEFAULT_TRAVEL_FEATURE_ICONS.length];
